import { AppConfig } from "AppConfig";
import { getRequestHeaders } from "msal/MsalAuthProvider";
import { createLog } from "_data/services/extract/service";

export const getUserInfoRequest = (callback, attempt = 0) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/auth/me`;

  fetch(url, {
    method: "GET",
    headers: getRequestHeaders(),
  })
    .then((response) => response.json())
    .then((response) => {
      callback(true, response);
    })
    .catch((error) => {
      // This fires on every page load (Header mount), the coldest moment for the browser's
      // network stack -- a single retry absorbs most of that transient class of failure
      // instead of leaving license-gated UI silently stuck on stale/missing user info.
      if (attempt < 1) {
        setTimeout(() => getUserInfoRequest(callback, attempt + 1), 1000);
        return;
      }
      callback(false, null);
      createLog("Error", `Get User Info : ${error}`);
    });
};

export const deleteUserRequest = (callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/auth/me`;

  fetch(url, {
    method: "DELETE",
    headers: getRequestHeaders(),
  })
    .then((response) => {
      response.json();
    })
    .then(() => callback())
    .catch((error) => {
      createLog("Error", `Delete User : ${error}`);
    });
};
